export const installTranslations = {
  en: {
    meta: {
      title: "Install CheckFirst App | Get the Mobile Experience",
      description: "Install CheckFirst on your device for quick access to AI-powered healthcare triage. Works offline, loads instantly, and feels like a native app."
    },
    hero: {
      title: "Install CheckFirst",
      subtitle: "Get instant access to AI-powered healthcare triage right from your home screen. No app store needed.",
      installedMessage: "App is installed!",
      installButton: "Install Now",
      followInstructions: "Follow the instructions below for your device"
    },
    features: {
      fast: { title: "Fast & Responsive", description: "Lightning-fast load times, even offline" },
      offline: { title: "Works Offline", description: "Access your health info without internet" },
      notifications: { title: "Push Notifications", description: "Stay updated with health reminders" }
    },
    instructions: {
      title: "Installation Instructions",
      yourDevice: "Your device",
      ios: {
        title: "iPhone & iPad",
        subtitle: "Safari browser",
        steps: [
          { title: "Open in Safari", description: "This must be done in Safari browser" },
          { title: "Tap Share", description: "Located at the bottom of the screen" },
          { title: "Add to Home Screen", description: "Scroll down in the share menu" },
          { title: "Tap Add", description: "Confirm to add the app" }
        ]
      },
      android: {
        title: "Android",
        subtitle: "Chrome browser",
        steps: [
          { title: "Open in Chrome", description: "Works best with Chrome browser" },
          { title: "Tap Menu", description: "Three dots in the top right" },
          { title: "Install App", description: 'Or "Add to Home Screen"' },
          { title: "Tap Install", description: "Confirm the installation" }
        ]
      },
      desktop: {
        title: "Desktop",
        subtitle: "Chrome, Edge, or Brave",
        steps: [
          { title: "Look for install icon", description: "In the address bar (right side)" },
          { title: "Click Install", description: "Or use the button above" },
          { title: "Confirm installation", description: "App will open in its own window" },
          { title: "Find in apps", description: "Available in your start menu/dock" }
        ]
      }
    },
    cta: {
      title: "Ready to get started?",
      subtitle: "Start your first health assessment today",
      button: "Start Health Assessment"
    }
  },
  es: {
    meta: {
      title: "Instalar CheckFirst | Obtén la Experiencia Móvil",
      description: "Instala CheckFirst en tu dispositivo para acceso rápido al triaje de salud impulsado por IA. Funciona sin conexión, carga instantáneamente."
    },
    hero: {
      title: "Instalar CheckFirst",
      subtitle: "Obtén acceso instantáneo al triaje de salud impulsado por IA directamente desde tu pantalla de inicio. No necesitas tienda de aplicaciones.",
      installedMessage: "¡La aplicación está instalada!",
      installButton: "Instalar Ahora",
      followInstructions: "Sigue las instrucciones a continuación para tu dispositivo"
    },
    features: {
      fast: { title: "Rápido y Responsivo", description: "Tiempos de carga ultrarrápidos, incluso sin conexión" },
      offline: { title: "Funciona Sin Conexión", description: "Accede a tu información de salud sin internet" },
      notifications: { title: "Notificaciones Push", description: "Mantente actualizado con recordatorios de salud" }
    },
    instructions: {
      title: "Instrucciones de Instalación",
      yourDevice: "Tu dispositivo",
      ios: {
        title: "iPhone y iPad",
        subtitle: "Navegador Safari",
        steps: [
          { title: "Abre en Safari", description: "Esto debe hacerse en el navegador Safari" },
          { title: "Toca Compartir", description: "Ubicado en la parte inferior de la pantalla" },
          { title: "Agregar a Pantalla de Inicio", description: "Desplázate hacia abajo en el menú de compartir" },
          { title: "Toca Agregar", description: "Confirma para agregar la aplicación" }
        ]
      },
      android: {
        title: "Android",
        subtitle: "Navegador Chrome",
        steps: [
          { title: "Abre en Chrome", description: "Funciona mejor con el navegador Chrome" },
          { title: "Toca Menú", description: "Tres puntos en la esquina superior derecha" },
          { title: "Instalar Aplicación", description: 'O "Agregar a Pantalla de Inicio"' },
          { title: "Toca Instalar", description: "Confirma la instalación" }
        ]
      },
      desktop: {
        title: "Escritorio",
        subtitle: "Chrome, Edge o Brave",
        steps: [
          { title: "Busca el ícono de instalación", description: "En la barra de direcciones (lado derecho)" },
          { title: "Haz clic en Instalar", description: "O usa el botón de arriba" },
          { title: "Confirma la instalación", description: "La aplicación se abrirá en su propia ventana" },
          { title: "Encuentra en aplicaciones", description: "Disponible en tu menú de inicio/dock" }
        ]
      }
    },
    cta: {
      title: "¿Listo para comenzar?",
      subtitle: "Comienza tu primera evaluación de salud hoy",
      button: "Iniciar Evaluación de Salud"
    }
  },
  hi: {
    meta: {
      title: "CheckFirst ऐप इंस्टॉल करें | मोबाइल अनुभव प्राप्त करें",
      description: "AI-संचालित स्वास्थ्य ट्राइएज तक त्वरित पहुंच के लिए अपने डिवाइस पर CheckFirst इंस्टॉल करें। ऑफ़लाइन काम करता है, तुरंत लोड होता है।"
    },
    hero: {
      title: "CheckFirst इंस्टॉल करें",
      subtitle: "अपनी होम स्क्रीन से सीधे AI-संचालित स्वास्थ्य ट्राइएज तक त्वरित पहुंच प्राप्त करें। ऐप स्टोर की आवश्यकता नहीं।",
      installedMessage: "ऐप इंस्टॉल हो गया है!",
      installButton: "अभी इंस्टॉल करें",
      followInstructions: "अपने डिवाइस के लिए नीचे दिए गए निर्देशों का पालन करें"
    },
    features: {
      fast: { title: "तेज़ और प्रतिक्रियाशील", description: "बिजली की तरह तेज़ लोड समय, ऑफ़लाइन भी" },
      offline: { title: "ऑफ़लाइन काम करता है", description: "इंटरनेट के बिना अपनी स्वास्थ्य जानकारी एक्सेस करें" },
      notifications: { title: "पुश नोटिफिकेशन", description: "स्वास्थ्य रिमाइंडर के साथ अपडेट रहें" }
    },
    instructions: {
      title: "इंस्टॉलेशन निर्देश",
      yourDevice: "आपका डिवाइस",
      ios: {
        title: "iPhone और iPad",
        subtitle: "Safari ब्राउज़र",
        steps: [
          { title: "Safari में खोलें", description: "यह Safari ब्राउज़र में किया जाना चाहिए" },
          { title: "Share टैप करें", description: "स्क्रीन के नीचे स्थित है" },
          { title: "होम स्क्रीन में जोड़ें", description: "शेयर मेनू में नीचे स्क्रॉल करें" },
          { title: "Add टैप करें", description: "ऐप जोड़ने की पुष्टि करें" }
        ]
      },
      android: {
        title: "Android",
        subtitle: "Chrome ब्राउज़र",
        steps: [
          { title: "Chrome में खोलें", description: "Chrome ब्राउज़र के साथ सबसे अच्छा काम करता है" },
          { title: "Menu टैप करें", description: "ऊपर दाईं ओर तीन बिंदु" },
          { title: "ऐप इंस्टॉल करें", description: 'या "होम स्क्रीन में जोड़ें"' },
          { title: "Install टैप करें", description: "इंस्टॉलेशन की पुष्टि करें" }
        ]
      },
      desktop: {
        title: "डेस्कटॉप",
        subtitle: "Chrome, Edge, या Brave",
        steps: [
          { title: "इंस्टॉल आइकन देखें", description: "एड्रेस बार में (दाईं ओर)" },
          { title: "Install क्लिक करें", description: "या ऊपर वाला बटन उपयोग करें" },
          { title: "इंस्टॉलेशन की पुष्टि करें", description: "ऐप अपनी विंडो में खुलेगा" },
          { title: "ऐप्स में खोजें", description: "आपके स्टार्ट मेनू/डॉक में उपलब्ध" }
        ]
      }
    },
    cta: {
      title: "शुरू करने के लिए तैयार?",
      subtitle: "आज अपना पहला स्वास्थ्य मूल्यांकन शुरू करें",
      button: "स्वास्थ्य मूल्यांकन शुरू करें"
    }
  },
  pa: {
    meta: {
      title: "CheckFirst ਐਪ ਇੰਸਟਾਲ ਕਰੋ | ਮੋਬਾਈਲ ਅਨੁਭਵ ਪ੍ਰਾਪਤ ਕਰੋ",
      description: "AI-ਸੰਚਾਲਿਤ ਸਿਹਤ ਟ੍ਰਾਇਜ ਤੱਕ ਤੁਰੰਤ ਪਹੁੰਚ ਲਈ ਆਪਣੀ ਡਿਵਾਈਸ ਤੇ CheckFirst ਇੰਸਟਾਲ ਕਰੋ। ਆਫ਼ਲਾਈਨ ਕੰਮ ਕਰਦਾ ਹੈ।"
    },
    hero: {
      title: "CheckFirst ਇੰਸਟਾਲ ਕਰੋ",
      subtitle: "ਆਪਣੀ ਹੋਮ ਸਕ੍ਰੀਨ ਤੋਂ ਸਿੱਧੇ AI-ਸੰਚਾਲਿਤ ਸਿਹਤ ਟ੍ਰਾਇਜ ਤੱਕ ਤੁਰੰਤ ਪਹੁੰਚ ਪ੍ਰਾਪਤ ਕਰੋ। ਐਪ ਸਟੋਰ ਦੀ ਲੋੜ ਨਹੀਂ।",
      installedMessage: "ਐਪ ਇੰਸਟਾਲ ਹੋ ਗਈ ਹੈ!",
      installButton: "ਹੁਣੇ ਇੰਸਟਾਲ ਕਰੋ",
      followInstructions: "ਆਪਣੀ ਡਿਵਾਈਸ ਲਈ ਹੇਠਾਂ ਦਿੱਤੀਆਂ ਹਿਦਾਇਤਾਂ ਦੀ ਪਾਲਣਾ ਕਰੋ"
    },
    features: {
      fast: { title: "ਤੇਜ਼ ਅਤੇ ਜਵਾਬਦੇਹ", description: "ਬਿਜਲੀ ਵਰਗੀ ਤੇਜ਼ ਲੋਡਿੰਗ, ਆਫ਼ਲਾਈਨ ਵੀ" },
      offline: { title: "ਆਫ਼ਲਾਈਨ ਕੰਮ ਕਰਦਾ ਹੈ", description: "ਇੰਟਰਨੈੱਟ ਤੋਂ ਬਿਨਾਂ ਆਪਣੀ ਸਿਹਤ ਜਾਣਕਾਰੀ ਐਕਸੈਸ ਕਰੋ" },
      notifications: { title: "ਪੁਸ਼ ਨੋਟੀਫਿਕੇਸ਼ਨ", description: "ਸਿਹਤ ਰੀਮਾਈਂਡਰਾਂ ਨਾਲ ਅੱਪਡੇਟ ਰਹੋ" }
    },
    instructions: {
      title: "ਇੰਸਟਾਲੇਸ਼ਨ ਹਿਦਾਇਤਾਂ",
      yourDevice: "ਤੁਹਾਡੀ ਡਿਵਾਈਸ",
      ios: {
        title: "iPhone ਅਤੇ iPad",
        subtitle: "Safari ਬ੍ਰਾਊਜ਼ਰ",
        steps: [
          { title: "Safari ਵਿੱਚ ਖੋਲ੍ਹੋ", description: "ਇਹ Safari ਬ੍ਰਾਊਜ਼ਰ ਵਿੱਚ ਕੀਤਾ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ" },
          { title: "Share ਟੈਪ ਕਰੋ", description: "ਸਕ੍ਰੀਨ ਦੇ ਹੇਠਾਂ ਸਥਿਤ ਹੈ" },
          { title: "ਹੋਮ ਸਕ੍ਰੀਨ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰੋ", description: "ਸ਼ੇਅਰ ਮੀਨੂ ਵਿੱਚ ਹੇਠਾਂ ਸਕ੍ਰੋਲ ਕਰੋ" },
          { title: "Add ਟੈਪ ਕਰੋ", description: "ਐਪ ਸ਼ਾਮਲ ਕਰਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ" }
        ]
      },
      android: {
        title: "Android",
        subtitle: "Chrome ਬ੍ਰਾਊਜ਼ਰ",
        steps: [
          { title: "Chrome ਵਿੱਚ ਖੋਲ੍ਹੋ", description: "Chrome ਬ੍ਰਾਊਜ਼ਰ ਨਾਲ ਸਭ ਤੋਂ ਵਧੀਆ ਕੰਮ ਕਰਦਾ ਹੈ" },
          { title: "Menu ਟੈਪ ਕਰੋ", description: "ਉੱਪਰ ਸੱਜੇ ਪਾਸੇ ਤਿੰਨ ਬਿੰਦੀਆਂ" },
          { title: "ਐਪ ਇੰਸਟਾਲ ਕਰੋ", description: 'ਜਾਂ "ਹੋਮ ਸਕ੍ਰੀਨ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰੋ"' },
          { title: "Install ਟੈਪ ਕਰੋ", description: "ਇੰਸਟਾਲੇਸ਼ਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ" }
        ]
      },
      desktop: {
        title: "ਡੈਸਕਟਾਪ",
        subtitle: "Chrome, Edge, ਜਾਂ Brave",
        steps: [
          { title: "ਇੰਸਟਾਲ ਆਈਕਨ ਲੱਭੋ", description: "ਐਡਰੈੱਸ ਬਾਰ ਵਿੱਚ (ਸੱਜੇ ਪਾਸੇ)" },
          { title: "Install ਕਲਿੱਕ ਕਰੋ", description: "ਜਾਂ ਉੱਪਰ ਵਾਲਾ ਬਟਨ ਵਰਤੋ" },
          { title: "ਇੰਸਟਾਲੇਸ਼ਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ", description: "ਐਪ ਆਪਣੀ ਵਿੰਡੋ ਵਿੱਚ ਖੁੱਲ੍ਹੇਗੀ" },
          { title: "ਐਪਸ ਵਿੱਚ ਲੱਭੋ", description: "ਤੁਹਾਡੇ ਸਟਾਰਟ ਮੀਨੂ/ਡੌਕ ਵਿੱਚ ਉਪਲਬਧ" }
        ]
      }
    },
    cta: {
      title: "ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਤਿਆਰ ਹੋ?",
      subtitle: "ਅੱਜ ਆਪਣਾ ਪਹਿਲਾ ਸਿਹਤ ਮੁਲਾਂਕਣ ਸ਼ੁਰੂ ਕਰੋ",
      button: "ਸਿਹਤ ਮੁਲਾਂਕਣ ਸ਼ੁਰੂ ਕਰੋ"
    }
  },
  bn: {
    meta: {
      title: "CheckFirst অ্যাপ ইনস্টল করুন | মোবাইল অভিজ্ঞতা পান",
      description: "AI-চালিত স্বাস্থ্য ট্রায়াজে দ্রুত অ্যাক্সেসের জন্য আপনার ডিভাইসে CheckFirst ইনস্টল করুন। অফলাইনে কাজ করে, তাৎক্ষণিক লোড হয়।"
    },
    hero: {
      title: "CheckFirst ইনস্টল করুন",
      subtitle: "আপনার হোম স্ক্রীন থেকে সরাসরি AI-চালিত স্বাস্থ্য ট্রায়াজে তাৎক্ষণিক অ্যাক্সেস পান। অ্যাপ স্টোরের প্রয়োজন নেই।",
      installedMessage: "অ্যাপ ইনস্টল হয়ে গেছে!",
      installButton: "এখনই ইনস্টল করুন",
      followInstructions: "আপনার ডিভাইসের জন্য নীচের নির্দেশাবলী অনুসরণ করুন"
    },
    features: {
      fast: { title: "দ্রুত এবং প্রতিক্রিয়াশীল", description: "বিদ্যুৎ-দ্রুত লোড সময়, অফলাইনেও" },
      offline: { title: "অফলাইনে কাজ করে", description: "ইন্টারনেট ছাড়াই আপনার স্বাস্থ্য তথ্য অ্যাক্সেস করুন" },
      notifications: { title: "পুশ নোটিফিকেশন", description: "স্বাস্থ্য রিমাইন্ডার দিয়ে আপডেট থাকুন" }
    },
    instructions: {
      title: "ইনস্টলেশন নির্দেশাবলী",
      yourDevice: "আপনার ডিভাইস",
      ios: {
        title: "iPhone এবং iPad",
        subtitle: "Safari ব্রাউজার",
        steps: [
          { title: "Safari-তে খুলুন", description: "এটি অবশ্যই Safari ব্রাউজারে করতে হবে" },
          { title: "Share ট্যাপ করুন", description: "স্ক্রীনের নীচে অবস্থিত" },
          { title: "হোম স্ক্রীনে যোগ করুন", description: "শেয়ার মেনুতে নীচে স্ক্রোল করুন" },
          { title: "Add ট্যাপ করুন", description: "অ্যাপ যোগ করতে নিশ্চিত করুন" }
        ]
      },
      android: {
        title: "Android",
        subtitle: "Chrome ব্রাউজার",
        steps: [
          { title: "Chrome-এ খুলুন", description: "Chrome ব্রাউজারে সবচেয়ে ভালো কাজ করে" },
          { title: "Menu ট্যাপ করুন", description: "উপরে ডানদিকে তিনটি বিন্দু" },
          { title: "অ্যাপ ইনস্টল করুন", description: 'অথবা "হোম স্ক্রীনে যোগ করুন"' },
          { title: "Install ট্যাপ করুন", description: "ইনস্টলেশন নিশ্চিত করুন" }
        ]
      },
      desktop: {
        title: "ডেস্কটপ",
        subtitle: "Chrome, Edge, বা Brave",
        steps: [
          { title: "ইনস্টল আইকন খুঁজুন", description: "অ্যাড্রেস বারে (ডান দিকে)" },
          { title: "Install ক্লিক করুন", description: "অথবা উপরের বোতাম ব্যবহার করুন" },
          { title: "ইনস্টলেশন নিশ্চিত করুন", description: "অ্যাপ নিজস্ব উইন্ডোতে খুলবে" },
          { title: "অ্যাপসে খুঁজুন", description: "আপনার স্টার্ট মেনু/ডকে উপলব্ধ" }
        ]
      }
    },
    cta: {
      title: "শুরু করতে প্রস্তুত?",
      subtitle: "আজই আপনার প্রথম স্বাস্থ্য মূল্যায়ন শুরু করুন",
      button: "স্বাস্থ্য মূল্যায়ন শুরু করুন"
    }
  }
} as const;

export type InstallTranslations = typeof installTranslations.en;
